import { getBarChartData, getBarChartLayout } from "./barChartConfig";
import { BarChartData, BarChartLayout } from "./barChartInterface";

import React from "react";
import Plot from "react-plotly.js";
import { getPlotConfig } from "../chartConfig";
import { ChartDivId } from "../chartInterface";

interface Props {
  divId: ChartDivId;
  data: BarChartData[];
  layout: BarChartLayout;
  isStackedBarChart: boolean;
}

export const BarChart = ({
  divId,
  data,
  layout,
  isStackedBarChart,
}: Props): React.ReactElement => {
  return (
    <Plot
      divId={divId}
      data={getBarChartData(data)}
      layout={getBarChartLayout(layout, isStackedBarChart)}
      config={getPlotConfig()}
      onLegendClick={() => false}
      onLegendDoubleClick={() => false}
    />
  );
};
